"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var FlotComponent = FlotComponent_1 = (function () {
    function FlotComponent(el) {
        this.el = el;
        this.width = '100%';
        this.height = 220;
    }
    FlotComponent.prototype.ngOnChanges = function (changes) {
        if (changes['refresh'] && !changes['refresh'].isFirstChange() && FlotComponent_1.initialized) {
            $.plot(this.plotArea, this.dataset, this.options);
        }
    };
    FlotComponent.prototype.ngAfterViewInit = function () {
        if (!FlotComponent_1.initialized) {
            this.plotArea = $(this.el.nativeElement).find('div').empty();
            this.plotArea.css({
                width: this.width,
                height: this.height
            });
            $.plot(this.plotArea, this.dataset, this.options);
            FlotComponent_1.initialized = true;
        }
    };
    return FlotComponent;
}());
FlotComponent.initialized = false;
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], FlotComponent.prototype, "refresh", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], FlotComponent.prototype, "dataset", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], FlotComponent.prototype, "options", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], FlotComponent.prototype, "width", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], FlotComponent.prototype, "height", void 0);
FlotComponent = FlotComponent_1 = __decorate([
    core_1.Component({
        selector: 'flot',
        template: "<div>Loading...</div>",
        changeDetection: core_1.ChangeDetectionStrategy.OnPush
    }),
    __metadata("design:paramtypes", [core_1.ElementRef])
], FlotComponent);
exports.FlotComponent = FlotComponent;
var FlotComponent_1;
//# sourceMappingURL=flot.component.js.map


//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/ng2modules-flot/flot.component.js
// module id = ../../../../ng2modules-flot/flot.component.js
// module chunks = 3